import React, { Component } from "react";
import "./PopularServicesItemList.css";
import PopularServicesItem from "./PopularServicesItem";
import { Swiper, SwiperSlide } from "swiper/react";
import SwiperCore, { Pagination } from "swiper";
import "swiper/swiper-bundle.min.css";
import "swiper/swiper.min.css";
import "swiper/components/pagination/pagination.min.css";

SwiperCore.use([Pagination]);

class PopularServicesItemList extends Component {
  constructor(props) {
    super(props);
  }

  render() {
    const { services } = this.props;

    return (
      <Swiper
        className="popular-services-swiper"
        modules={[Pagination]}
        keyboard
        watchOverflow
        slidesPerView={3}
        slidesPerColumn={1}
        centeredSlides={false}
        observeParents={true}
        breakpoints={{
          576: {
            slidesPerView: 4,
            slidesPerColumn: 1,
          },
          768: {
            slidesPerView: 3,
            slidesPerColumn: 3,
          },
        }}
        pagination={{
          clickable: true,
        }}
        slidesPerColumnFill="row"
      >
        {services.map((service, i) => (
          <SwiperSlide key={`popular-services-item-${i + 1}`}>
            <PopularServicesItem service={service} />
          </SwiperSlide>
        ))}
      </Swiper>
    );
  }
}

export default PopularServicesItemList;
